<template>
    <div v-if="show && lanEnv" class="personal">
        <span v-if="isPersonal">{{ anchorLan.pauth }}</span>
        <span v-else>{{ anchorLan.mauth }}</span>
        <van-icon class="icon" name="checked" color="rgb(213, 121, 88)" />
        <span v-if="through">{{ anchorLan.through }}</span>
    </div>
</template>
<script>
import { Icon } from 'vant'
import { personal } from '@/constant/storeData'
export default {
    components: {
        [Icon.name]: Icon
    },
    data() {
        return {
            show: false,
            isPersonal: false,
            anchorLan: this.$t('message.anchor'),
            lanEnv: 1
        }
    },
    props: {
        through: {
            type: Boolean,
            default: true
        },
        certification: {
            type: Number,
            default: 4
        }
    },
    watch: {
        certification: {
            handler: function (val) {
                if (val !== 0) {
                    this.show = true
                }
                const { storeId, hostId } = this.$route.query
                const id = storeId || hostId
                if (this.certification === 1 || this.certification === 3) {
                    this.isPersonal = true
                }
                personal.forEach(item => {
                    if (this.certification === 4 && (item.storeId === id || item.hostId === id)) {
                        this.isPersonal = true
                    }
                })
            },
            immediate: true
        }
    }
}
</script>
<style lang="less" scoped>
.personal{
    display: flex;
    align-items: center;
    font-size: 13px;
    span:first-child {
        color: rgb(213, 121, 88);
    }
    .icon{
        margin: 0 5px;
    }
}
</style>